"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("waypoints/lib/jquery.waypoints");

require("waypoints/lib/shortcuts/sticky");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $body = void 0;

var $document = void 0;
var Handbook = void 0;

$document = require("../helpers/helpers").default.document;

$body = require("../helpers/helpers").default.body;

Handbook = function () {
  var Handbook = function () {
    function Handbook() {
      _classCallCheck(this, Handbook);

      var me = void 0;
      me = this;
      this.$handbook_nav = (0, _jquery2.default)(".handbook-footer-navigation");
      this.$nav = (0, _jquery2.default)(".handbook-inpage-navigation ul");
      this.$nav_links = (0, _jquery2.default)(".handbook-inpage-navigation li");
      this.$section_block = (0, _jquery2.default)(".section-block");
      this.onLoad();
      this.changeNav();
    }

    _createClass(Handbook, [{
      key: "onLoad",
      value: function onLoad() {
        return $document.ready(function (_this) {
          return function () {
            var transitionTime = void 0;
            transitionTime = 500;
            _this.navigationWaypoints();
            _this.attachScrollWaypoint();
            return $document.on("click", ".handbook-inpage-navigation", function (_ref) {
              var target = _ref.target;

              var $this = void 0;
              $this = (0, _jquery2.default)(target);
              _this.$nav_links.removeClass("active");
              $this.parent().addClass("active");
              _this.animateTo((0, _jquery2.default)($this.attr("href")), transitionTime);
              Waypoint.destroyAll();
              _this.navigationWaypoints();
              return setTimeout(function () {
                return _this.attachScrollWaypoint();
              }, transitionTime * 2);
            });
          };
        }(this));
      }
    }, {
      key: "animateTo",
      value: function animateTo($this, animation_time) {
        return $body.animate({
          scrollTop: $this.offset().top
        }, animation_time);
      }
    }, {
      key: "changeNav",
      value: function changeNav() {
        switch (window.location.hash) {
          case "#technical_guidelines":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#technical_guidelines']").parent().addClass("active");
          case "#principles_of_design":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#principles_of_design']").parent().addClass("active");
          case "#collections":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#collections']").parent().addClass("active");
          case "#resources":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#resources']").parent().addClass("active");
          case "#how_to_name":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#how_to_name']").parent().addClass("active");
          case "#search_words":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#search_words']").parent().addClass("active");
          case "#licenses":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#licenses']").parent().addClass("active");
          case "#curation":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#curation']").parent().addClass("active");
          case "#getting_paid":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#getting_paid']").parent().addClass("active");
          case "#metrics":
            this.$nav_links.removeClass("active");
            return (0, _jquery2.default)("[href='#metrics']").parent().addClass("active");
        }
      }
    }, {
      key: "attachScrollWaypoint",
      value: function attachScrollWaypoint() {
        var me = void 0;
        me = this;
        return this.$section_block.waypoint({
          handler: function handler() {
            var hash = void 0;
            hash = (0, _jquery2.default)(this.element).data("hash");
            window.location.hash = hash;
            return me.changeNav();
          },
          offset: "30%"
        });
      }
    }, {
      key: "navigationWaypoints",
      value: function navigationWaypoints() {
        return new Waypoint.Sticky({
          element: this.$nav,
          offset: -24
        });
      }
    }]);

    return Handbook;
  }();

  return Handbook;
}();

exports.default = Handbook;